import { centerable, uploadable } from '../decorators';
import { BLOCK_CLASSES, ALIGN_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const imageSpec = centerable(uploadable({
  inline: false,
  draggable: true,
  attrs: {
    type: {
      default: 'image'
    },
    src: {},
    linkUrl: {
      default: ''
    },
    width: {
      default: ''
    },
    displayWidth: {
      default: ''
    },
    height: {
      default: ''
    },
    text: {
      default: ''
    }
  },
  group: 'block',
  parseDOM: [{
    tag: '.intercom-interblocks-image',
    priority: 60,
    getAttrs(dom) {
      let img = dom.querySelector('img');
      return {
        src: img.getAttribute('src'),
        text: img.getAttribute('alt')
      };
    }
  }, {
    tag: 'img[src]',
    getAttrs(dom) {
      return {
        src: dom.getAttribute('src'),
        linkUrl: dom.getAttribute('data-link-url'),
        width: dom.getAttribute('data-width') || dom.style.width.replace('px', ''),
        height: dom.getAttribute('data-height'),
        text: dom.getAttribute('alt')
      };
    }
  }],
  toDOM(node) {
    let {
      src,
      width,
      displayWidth,
      height,
      text
    } = node.attrs;
    displayWidth = displayWidth || width;
    return ['div', {
      class: `${BLOCK_CLASSES.blockContainer} ${BLOCK_CLASSES.image}`
    }, ['img', {
      src,
      ...(text && {
        alt: text
      }),
      class: `${ALIGN_CLASSES[node.attrs.alignment]}`,
      style: `display: block; width: ${displayWidth}px;`,
      'data-link-url': node.attrs.linkUrl,
      'data-height': height,
      'data-width': width
    }]];
  }
}));